/**
 * Environment Configuration
 * Centralized configuration for API URLs and other environment-specific settings
 */

// API Base URL - defaults to relative path if not set
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Microsoft Authentication (MSAL) Configuration
export const MSAL_CLIENT_ID = process.env.REACT_APP_MSAL_CLIENT_ID || '';
export const MSAL_TENANT_ID = process.env.REACT_APP_MSAL_TENANT_ID || '';
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || window.location.origin;

// API Version
export const API_VERSION = 'v2';

// Timeout Configuration
export const API_TIMEOUT = 30000; // 30 seconds

// Development Mode Detection
export const IS_DEV_ENVIRONMENT = 
  process.env.NODE_ENV === 'development' || 
  window.location.hostname.includes('dev.') ||
  window.location.hostname.includes('localhost') ||
  window.location.hostname.includes('127.0.0.1');

// Log environment on load (useful for debugging)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 [Environment] Configuration loaded:', {
    API_BASE_URL,
    MSAL_CLIENT_ID,
    MSAL_TENANT_ID,
    REDIRECT_URI,
    NODE_ENV: process.env.NODE_ENV,
    IS_DEV_ENVIRONMENT,
  });
}
